export default "__VITE_ASSET__2a1ed717__"